/*!
 * © 2024. The EGT Universe. All Rights Reserved.
 * License: Requires ACTIVE AppArtisan Subscription.
 * For mor information visit: https://egtuniverse.com/legal
 */

var _ = require("../../../uam/module.js")(module.exports, {
  namespace: "ua.error.stacktrace.line",
  title: "Stack Trace Line",
  description: "Renders a single stack trace line for fullscreen error details.",
  fields: {
    line: {
      title: "Line",
      type: "object",
      description: "The stack trace line object."
    }
  }
});

function text(value) {
  if (value === undefined || value === null) return "";
  return value.toString();
}

function buildSummary(line) {
  if (typeof line === "string") return line;
  if (!(line && typeof line === "object")) return "";

  if (line.s) return text(line.s);

  var fn = text(line.function || line.fn || line.method || "");
  var file = text(line.file || line.path || line.source || "");
  var ln = text(line.line || line.ln || "");
  var col = text(line.column || line.col || "");
  var message = text(line.message || "");

  var out = "";
  if (fn) out += fn;
  if (file) out += (out ? " @ " : "") + file;
  if (ln) out += (out ? ":" : "") + ln;
  if (col) out += (out ? ":" : "") + col;
  if (message) out += (out ? " - " : "") + message;
  return out;
}

exports.render = async function(options) {
  var line = (options || {}).line;
  var summary = buildSummary(line);

  return {
    n: "li",
    c: "ua-error-stacktrace-line",
    i: summary || "Unknown stack trace line."
  };
};

